export default __webpack_public_path__ + "static/media/historyVegetationImage.439e73ee.png";